import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const GenericToast = ({ open, onCloseHandler, label, duration = 6000 }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      onClose={onCloseHandler}
      autoHideDuration={duration}
    >
      <Alert
        onClose={onCloseHandler}
        severity="error"
        variant="filled"
        sx={{ width: "100%" }}
      >
        {label}
      </Alert>
    </Snackbar>
  );
};

export default GenericToast;
